import { css } from '@firebolt-dev/css'
import { XIcon } from 'lucide-react'
import { useEffect, useMemo, useRef, useState } from 'react'

export function UIEditorFieldAsset({ registry, type, value, onChange }) {
  const [registryV, setRegistryV] = useState(0)
  const inputRef = useRef()
  const [editing, setEditing] = useState(false)

  const match = useMemo(() => {
    if (!value) return ''
    return registry.raw.find(a => a.type === type && a.id === value)
  }, [value, registryV])

  const [text, setText] = useState(() => (match ? value : ''))

  useEffect(() => {
    // if matched sound no longer exists, set text to null
    if (!editing && text && !match) {
      setText('')
    }
  }, [match, text, editing])

  useEffect(() => {
    const onRegistryChange = () => {
      setRegistryV(n => n + 1)
    }
    registry.on('change', onRegistryChange)
    return () => {
      registry.off('change', onRegistryChange)
    }
  }, [])

  const assets = useMemo(() => {
    const q = text.toLowerCase()
    const assets = registry.raw.filter(asset => {
      return asset.type === type && asset.id.toLowerCase().includes(q)
    })
    assets.sort((a, b) => a.id.localeCompare(b.id)) // name asc
    return assets
  }, [editing, text, registryV])

  return (
    <label
      className='soundinput'
      css={css`
        display: flex;
        position: relative;
        height: 34px;
        padding: 0 0 0 10px;
        border-radius: 5px;
        background: var(--bg4);
        input {
          flex: 1;
          width: 100%;
        }
        .soundinput-clear {
          width: 32px;
          height: 32px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #535b70;
          &:hover {
            cursor: pointer;
            color: white;
          }
        }
        .soundinput-list {
          position: absolute;
          top: calc(100% + 2px);
          left: 0;
          right: 0;
          background: var(--bg4);
          border-radius: 5px;
          padding: 2px 0;
          z-index: 1;
          overflow: hidden;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.35);
        }
        .soundinput-list-item {
          padding: 8px 10px;
          &:hover {
            cursor: pointer;
            background: var(--bg5);
          }
        }
        &:focus-within {
          background: var(--bg5);
        }
      `}
      ref={inputRef}
      tabIndex={0}
      onFocus={() => setEditing(true)}
      onBlur={() => {
        setEditing(false)
        if (!text) setText(value || '')
      }}
    >
      <input
        type='text'
        value={text}
        onChange={e => {
          setText(e.target.value)
        }}
      />
      <div
        className='soundinput-clear'
        onPointerDown={e => {
          onChange(null)
          //   setText('')
          //   setTimeout(() => {
          //     inputRef.current.blur()
          //   })
        }}
      >
        <XIcon size={16} />
      </div>
      {editing && (
        <div className='soundinput-list'>
          {assets.map(asset => (
            <div
              key={asset.id}
              className='soundinput-list-item'
              onPointerDown={e => {
                setText(asset.id)
                onChange(asset.id)
                setTimeout(() => {
                  inputRef.current.blur()
                })
              }}
            >
              <span>{asset.id}</span>
            </div>
          ))}
        </div>
      )}
    </label>
  )
}
